import { createAction, props } from '@ngrx/store';

export const authLogout = createAction('[Auth] Logout');

export const authLogin = createAction('[Auth] Login', props<{ username: string; password: string }>());

export const authLoginSuccess = createAction('[Auth] Login Success', props<{ isAuthenticated: boolean }>());

export const authLoginFailure = createAction('[Auth] Login Failure', props<{ isAuthenticated: boolean; error: any }>());
